export default {
  inject: ['load'],
  data() {
    return {
      allChestPainLocationsForOther: [],
      chestPainLocation: null,
    };
  },
  methods: {
    getListOfChestPainLocationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllChestPainLocations').then(() => {
        if (this.$store.state.chestPainLocationModule.successFlag) {
          this.allChestPainLocationsForOther =
            this.$store.state.chestPainLocationModule.allChestPainLocations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfChestPainLocationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getChestPainLocationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getChestPainLocation', id).then(() => {
        if (this.$store.state.chestPainLocationModule.successFlag) {
          this.chestPainLocation = this.$store.state.chestPainLocationModule.chestPainLocation;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.chestPainLocationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getChestPainLocationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.chestPainLocationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
